<template>
  <el-row class="core_two_wrap">
    <el-col class="two_left">
      <div class="left_tit">
        {{ core.subTitle }}
      </div>
      <div class="left_desc" v-html="core.desc"></div>
      <el-row class="icon_wrap">
        <el-col class="icon_item" v-for="item in core.children.slice(0, 4)">
          <div v-html="item">
          </div>
        </el-col>
      </el-row>
      <el-row class="icon_wrap">
        <el-col class="icon_item" v-for="item in core.children.slice(4, 7)">
          <div v-html="item">
          </div>
        </el-col>
      </el-row>
      <el-row class="icon_wrap">
        <el-col class="icon_item" v-for="item in core.children.slice(7, 11)">
          <div v-html="item">
          </div>
        </el-col>
      </el-row>
    </el-col>
    <el-col class="two_right">
      <img :src="core.image" alt="">
    </el-col>
  </el-row>
</template>

<script>
export default {
  props: {
    core: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.core_two_wrap {
  display: flex;
  justify-content: center;
  text-align: left;

  @media screen and (max-width: 768px) {
    margin-top: 25px;
    flex-wrap: wrap;
    padding: 0 10px;
    margin-bottom: 20px;
  }

  .two_left {
    width: 40%;
    padding: 20px 50px 20px 50px;

    @media screen and (max-width: 768px) {
      width: 100%;
      margin-bottom: 15px;
    }

    .left_tit {
      font-size: 23px;
      font-weight: bold;
      color: #3e3e3e;

      @media screen and (max-width: 768px) {
        font-size: 1.4rem;
        margin-top: 10px;
        line-height: 1.4;
        padding: 0 5px;
      }
    }

    .left_desc {
      color: #717171;
      padding: 30px 40px 20px 40px;
      line-height: 25px;
      font-size: 18px;
      margin-bottom: 20px;

      @media screen and (max-width: 768px) {
        width: 88%;
        font-size: 14px;
        padding: 10px 5px 15px 5px;
        margin-bottom: 10px;
        margin-left: auto;
        margin-right: auto;
        line-height: 1.6;
      }

      ::v-deep span {
        color: #ffa400;
        font-size: 24px;
        padding: 0 10px;

        @media screen and (max-width: 768px) {
          font-size: 1.1rem;
          padding: 0 5px;
        }
      }
    }

    ::v-deep .icon_wrap {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;

      &:nth-child(n+2) {
        margin-top: -20px;
      }

      .icon_item {
        background: url('../../assets/img/types.png') 0 0 no-repeat;
        background-size: 100% 100%;
        width: 120px;
        height: 135px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        margin-right: 10px;

        @media screen and (max-width: 768px) {
          width: 20%;
          height: 80px;
          margin-right: 4px;
          margin-left: 4px;
        }

        .icon_title {
          color: #717171;
          font-size: 22px;
          font-weight: bold;

          @media screen and (max-width: 768px) {
            font-size: 0.8rem;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            padding: 0 3px;
          }
        }

        .icon_desc {
          color: #717171;
          font-size: 14px;
          margin-top: 12px;

          @media screen and (max-width: 768px) {
            font-size: 0.65rem;
            margin-top: 5px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            padding: 0 3px;
          }
        }
      }
    }
  }

  .two_right {
    width: 25%;
    height: 100%;

    @media screen and (max-width: 768px) {
      width: 90%;
      margin-top: 10px;
      display: flex;
      justify-content: center;
    }

    img {
      width: 100%;
      margin-top: 40px;

      @media screen and (max-width: 768px) {
        margin-top: 0;
        max-width: 320px;
        height: auto;
      }
    }
  }
}
</style>